module.exports = __webpack_public_path__ + "img/default_offer.edd036a9.jpg";